import { FormFieldSet } from "@progress/kendo-react-all";
import IncidentUploadCell from "./IncidentUploadCell";

export interface ResignationTerminationRowProps {
  control: any;
  setValue: any;
  incidentRecordId: string | undefined;
  resignationFileFieldTypeId: number;
  terminationFileFieldTypeId: number;
  resignationLocked?: boolean;
  terminationLocked?: boolean;
  /** Per the process-flow diagram, Termination is required once the Guilty -> Termination
   *  branch is taken (Task 157795) - false everywhere else, including AWOL (which resolves
   *  completion through the AWOL Letter -> NOH -> T/BWL chain instead, not Decision/
   *  DisciplinaryAction). */
  terminationRequired?: boolean;
  /** See ControlledFileUploaderProps.loading. */
  loading?: boolean;
}

const ResignationTerminationRow = ({
  control,
  setValue,
  incidentRecordId,
  resignationFileFieldTypeId,
  terminationFileFieldTypeId,
  resignationLocked,
  terminationLocked,
  terminationRequired,
  loading,
}: ResignationTerminationRowProps) => (
  <FormFieldSet cols={2}>
    <IncidentUploadCell
      control={control}
      setValue={setValue}
      name="resignation"
      incidentRecordId={incidentRecordId}
      fileFieldTypeId={resignationFileFieldTypeId}
      disabled={resignationLocked}
      loading={loading}
      label="Resignation"
      widthPercent={70}
    />
    <IncidentUploadCell
      control={control}
      setValue={setValue}
      name="termination"
      incidentRecordId={incidentRecordId}
      fileFieldTypeId={terminationFileFieldTypeId}
      disabled={terminationLocked}
      required={terminationRequired}
      loading={loading}
      label="Termination"
      widthPercent={70}
    />
  </FormFieldSet>
);

export default ResignationTerminationRow;
